import { Menu } from 'lucide-react';

import { useDashboardContext } from '@/stores/context/dashboard-layout-context';

import { Container } from '../../custom/container';
import Logo from '../shared/logo';

import UserProfile from './profile-layout';

const Header = () => {
  const { toggleSidebar } = useDashboardContext();

  return (
    <div className="fixed z-10 w-full px-4">
      <div className="flex w-full flex-row bg-[#f2f2f8] px-6 pt-[26px]" />
      <div className="flex w-full flex-row items-center justify-between rounded-md bg-white px-6 shadow">
        <div
          className="flex items-center justify-center max-sm:p-3 md:hidden"
          onClick={toggleSidebar}
        >
          <Menu className="h-5 w-5" />
        </div>
        <div className="hidden md:flex">
          <Logo showLabels />
        </div>
        <div className="flex items-center gap-3">
          <Container direction="row" className="items-center max-sm:p-3">
            <UserProfile />
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Header;
